module.exports = __webpack_public_path__ + "static/media/APP_Scientist_152x174_1.6f1af255.png";